// extracted by extract-css-chunks-webpack-plugin
module.exports = {"escda":"PageFooter-447884c52874044f","isHiddenOnMobile":"PageFooter-827b7fe88d0df923"};